import type { SchemaInput } from '../shared/schema-input.js';
import {
  compressText,
  consumeSessionHashDraft,
  decodeCompressedJson,
  setUrlHash
} from './url-state.js';

export async function saveNavigationDraft({
  storageKey,
  hasState,
  encodeState,
  saveErrorMessage = 'Failed to save navigation draft:'
}: {
  storageKey: string;
  hasState: () => boolean;
  encodeState: () => string;
  saveErrorMessage?: string;
}) {
  try {
    if (!hasState()) {
      sessionStorage.removeItem(storageKey);
      return true;
    }
    sessionStorage.setItem(storageKey, await compressText(encodeState()));
    return true;
  } catch (error) {
    console.error(saveErrorMessage, error);
    return false;
  }
}

export async function loadSharedLinkState({
  storageKey,
  savedHash = null,
  draftErrorMessage = 'Failed to restore navigation draft:',
  decodeErrorMessage = 'Failed to decode state:',
  onInvalidState,
  applyState
}: {
  storageKey: string;
  savedHash?: string | null;
  draftErrorMessage?: string;
  decodeErrorMessage?: string;
  onInvalidState: () => void;
  applyState: (data: SchemaInput) => Promise<void>;
}) {
  let hash = window.location.hash.slice(1);
  if (!hash) {
    const draftHash = consumeSessionHashDraft(storageKey, {
      errorMessage: draftErrorMessage
    });
    if (draftHash) {
      hash = draftHash;
      setUrlHash(hash);
    }
  }

  if (!hash && savedHash) { hash = savedHash; setUrlHash(hash); }
  if (!hash) return false;

  const data = await decodeCompressedJson(hash, {
    errorMessage: decodeErrorMessage,
    reportError: false,
  });
  if (!data) {
    onInvalidState();
    return false;
  }

  await applyState(data);
  return true;
}
